// Design tokens — Conta / Perfil. Ref: .md/DESIGN_UIUX.md

export const PERFIL_COMPONENT_DESIGN = {
  root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',
  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
  topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-0',
  topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  tabsList:
    'flex h-auto w-full items-center justify-start gap-[26px] rounded-none bg-transparent p-0 mt-3.5 overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
  tab:
    'flex-shrink-0 rounded-none bg-transparent px-0.5 py-0 pt-2.5 pb-3 text-[14px] font-medium text-[#71717a] whitespace-nowrap transition-colors hover:text-[#18181b] data-[state=active]:bg-transparent data-[state=active]:text-[#6d28d9] data-[state=active]:font-semibold data-[state=active]:shadow-[inset_0_-2px_0_#6d28d9]',
  sectionHeader: 'mt-[18px] first:mt-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',
  card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[26px] overflow-hidden min-w-0',
  stack: 'flex flex-col gap-3.5',
  avatar: {
    container: 'mb-2',
    wrapper: 'flex items-center gap-4',
    imageContainer:
      'relative w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] flex items-center justify-center overflow-hidden cursor-pointer group shrink-0',
    image: 'w-full h-full object-cover',
    placeholder: 'text-[#6d28d9]',
    overlay: 'absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity',
    name: 'text-[15px] font-semibold text-[#18181b]',
    email: 'text-[13px] text-[#71717a] mt-0.5',
    changeButton: 'text-[13px] font-semibold text-[#6d28d9] hover:text-[#5b21b6] hover:underline mt-1.5',
  },
  divider: 'h-px bg-[#f0f0f3] my-5',
};

PERFIL_COMPONENT_DESIGN.page = {
  container: PERFIL_COMPONENT_DESIGN.root,
  header: {
    container: PERFIL_COMPONENT_DESIGN.topbar,
    title: PERFIL_COMPONENT_DESIGN.title,
    subtitle: PERFIL_COMPONENT_DESIGN.subtitle,
  },
};
PERFIL_COMPONENT_DESIGN.tabs = {
  list: PERFIL_COMPONENT_DESIGN.tabsList,
  trigger: PERFIL_COMPONENT_DESIGN.tab,
};
PERFIL_COMPONENT_DESIGN.section = {
  card: PERFIL_COMPONENT_DESIGN.card,
  titleRow: 'hidden',
  iconBox: 'hidden',
  icon: 'hidden',
  title: 'hidden',
  description: 'hidden',
};

export default PERFIL_COMPONENT_DESIGN;
